// 2023/10/10 Leading Win 作業員シフト表廃止対応 start
// import { unwrapResult } from '@reduxjs/toolkit';
// import { GanttChart } from 'components';
// import { ContainerChangeTime } from 'containers/GranttChart';
// import { WORKER_SCHEDULE_STATUS } from 'constant';
// import { useAppDispatch } from 'hooks';
// 2023/10/10 Leading Win 作業員シフト表廃止対応 end
import { dayjs } from 'libs';
// 2023/10/10 Leading Win 作業員シフト表廃止対応 start
// import { flatMap, uniqueId } from 'lodash';
// import { FC, useEffect, useMemo, useRef, useState } from 'react';
// import { SiteCooperatorListItem, WorkerShift } from 'types';
// import SectionStyled from './styles';
// import { getSiteShopList } from './thunk';

// type Props = {
//   building_id?: number | string;
// };

// const TableGantt: FC<Props> = ({ building_id }) => {
//   const [currentDate, setCurrentDate] = useState<Date>(dayjs().endOf('month').toDate());
//   const [data, setDataNew] = useState<WorkerShift[]>([]);
//   const [loading, setLoading] = useState<boolean>(false);
//   const dispatch = useAppDispatch();
//   const load = useRef(1);
//   load.current += 1;

//   const genTextLabel = (status: number) => {
//     switch (status) {
//       case 0:
//         return WORKER_SCHEDULE_STATUS[0];
//       case 1:
//         return WORKER_SCHEDULE_STATUS[1];
//       case 2:
//         return WORKER_SCHEDULE_STATUS[2];
//       default:
//         break;
//     }
//     return status;
//   };

//   const convertDataTask = useMemo(
//     () => (item: SiteCooperatorListItem) => {
//       let dataTask: any[] = [];

//       if (item.schedules && item.schedules.length > 0) {
//         dataTask.push({
//           id: item.cooperator_id + item.work_type_name + item.cooperator_company_name,
//           work_type: item.work_type_name,
//           text: item.cooperator_company_name,
//           start_date: dayjs(item.schedules[0].start_date).format('YYYY-MM-DD'),
//           end_date: dayjs(item.schedules[0].end_date).format('YYYY-MM-DD'),
//           render: 'split',
//           open: true,
//         });
//         for (let index = 0; index < item.schedules.length; index++) {
//           dataTask.push({
//             id:
//               +item.cooperator_id +
//               item.work_type_name +
//               item.cooperator_company_name +
//               index +
//               uniqueId(),
//             work_type: item.work_type_name,
//             text: item.cooperator_company_name,
//             start_date: dayjs(item.schedules[index]?.start_date).format('YYYY-MM-DD'),
//             end_date: dayjs(item.schedules[index]?.end_date).format('YYYY-MM-DD'),
//             parent: item.cooperator_id + item.work_type_name + item.cooperator_company_name,
//             className: checkHasDate({
//               endDate: item.schedules[index]?.end_date,
//               startDate: item.schedules[index]?.start_date,
//             })
//               ? 'primary'
//               : 'disable',
//             open: true,
//             label: genTextLabel(item.worker_schedule_status),
//           });
//         }
//       }

//       return dataTask;
//     },
//     []
//   );

//   useEffect(() => {
//     async function getDataChart() {
//       try {
//         if (building_id) {
//           setLoading(true);
//           const dataSiteShopList = await dispatch(
//             getSiteShopList({
//               date: currentDate,
//               building_id,
//             })
//           );
//           const { cooperators } = unwrapResult(dataSiteShopList);
//           const dataTask = cooperators.map((item) => convertDataTask(item));
//           dataTask && dataTask.length > 0 && setDataNew(flatMap(dataTask));
//           setLoading(false);
//         }
//       } catch (error) {
//         setLoading(false);
//         console.log(error);
//       }
//     }
//     getDataChart();
//   }, [building_id, convertDataTask, currentDate, dispatch]);

//   return (
//     <SectionStyled>
//       <>
//         <div className="d-flex mb-16">
//           <ContainerChangeTime onChangeDate={setCurrentDate} />
//         </div>
//         {data && (
//           <GanttChart
//             width={'auto'}
//             height={'256px'}
//             type={'group'}
//             columGranttGroup={[
//               {
//                 name: 'work_type',
//                 label: '工種',
//                 width: 70,
//               },
//               {
//                 name: 'text',
//                 label: '協力業者',
//                 width: 128,
//                 tree: true,
//               },
//             ]}
//             onChangeDate={setCurrentDate}
//             currentDate={currentDate}
//             data={data}
//             loading={loading}
//           />
//         )}
//       </>
//     </SectionStyled>
//   );
// };
// 2023/10/10 Leading Win 作業員シフト表廃止対応 end
export const checkHasDate = ({
  endDate,
  startDate,
  currentDate = new Date(),
}: {
  endDate?: string | Date;
  startDate?: Date | string;
  currentDate?: Date | string;
}) => {
  return dayjs(dayjs(currentDate).format('YYYY-MM-DD')).isBetween(
    dayjs(dayjs(startDate).format('YYYY-MM-DD')),
    dayjs(dayjs(endDate).format('YYYY-MM-DD')),
    'day',
    '[]'
  );
};
// 2023/10/10 Leading Win 作業員シフト表廃止対応 start
// export default TableGantt;
export default checkHasDate;
// 2023/10/10 Leading Win 作業員シフト表廃止対応 end
